import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { Box,Grid } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import MainLayout from '../components/common/layout/MainLayout'
import SavingsLeftNavigation from '../components/savings/navigation/savingsLeftNavigation';
import SavingsMobileNavigation from '../components/savings/navigation/savingsMobileNavigation';
import SavingsReport from '../components/savings/savingsReport';
import { DataContext, DataDispatchContext } from '../contexts/data/dataContext'
import custom from '../styles/mui/szVariables.json'
import { analyticsDomain, analyticsCta } from '../services/constants'
import { sendClickAnalytics } from '../components/common/util/util'
import { 
  calendarIcon,
} from '../components/common/iconPaths'

export default function Savings() {
  const navigate = useNavigate()
  const data = useContext(DataContext)
  const dispatch: any = useContext(DataDispatchContext)  
  const tablet = useMediaQuery('(max-width:1100px)');

  const navItemList = (data?.savings || []).map((r: any)=>(
    {
      id: r.id,
      name: `${r.id}`.split('-')[1],
      iconPath: calendarIcon,
      selected: calendarIcon,
    }
  ))

  const clickAnalytics = ()=>{
    sendClickAnalytics('/savings', {
      domain: analyticsDomain.savings,
      name: analyticsCta.sunshineReport,
      metadata: {},
    })
  }

  useEffect(() => {
    window.scrollTo(0,0)
    if(data?.rightPanel?.key!=='help'
        && data?.rightPanel?.key!=='referral'
    ) {
      dispatch({
        type: 'setRightPanel',
        rightPanel: null
      })
    }
    if(data?.customer?.hasUsageData===false) {
      navigate('/')
    }
    if(!Array.isArray(data?.savings) || 
        data?.savings.length===0) {
      navigate('/')
    }
  },[
    dispatch, 
    navigate, 
    data?.rightPanel, 
    data?.customer?.hasUsageData
  ])

  return (
    <MainLayout>
      <Box display="flex" 
            flexDirection="row" 
            id="savingsReportContent"
            justifyContent="flex-start"
            maxWidth={"100%"}
            pb={custom.spacing.xl}
          >
          <Grid container direction={"column"} 
              justifyContent={"center"}>
              <Grid item maxWidth="100%" 
                borderBottom={custom.border}
                display={{ 
                  xs: 'flex', 
                  sm: 'flex', 
                  md: (data?.rightPanel && tablet)?'flex':'none', 
                  lg: 'none'
                }}
                >
                <SavingsMobileNavigation 
                    clickAnalytics={clickAnalytics}
                    navItems={navItemList}/>
              </Grid>
              <Grid item maxWidth="100%" >
                <Grid container direction="row" 
                    justifyContent={"center"} maxWidth="100%">
                  <Grid item 
                      width={{
                        xs: 0,
                        sm: 0,
                        md: (data.rightPanel && tablet)?0:'234px', 
                        lg: "234px",
                      }}
                      display={{ 
                        xs: 'none', 
                        sm: 'none', 
                        md: (data?.rightPanel && tablet)?'none':'flex', 
                        lg: 'flex'
                      }}>
                      <SavingsLeftNavigation 
                        clickAnalytics={clickAnalytics}
                        navItems={navItemList}/>
                  </Grid>
                  <Grid item xs >
                      <SavingsReport />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
      </Box>
    </MainLayout>
  )
}
